import { FleekError } from './FleekError';

type ObjectId = {
  id?: string;
};

type PersonalAccessTokenNotFoundErrorOptions = {
  personalAccessToken: ObjectId;
};

export class PersonalAccessTokenNotFoundError extends FleekError<PersonalAccessTokenNotFoundErrorOptions> {
  public name = 'PersonalAccessTokenNotFoundError';

  toString = () => `Personal access token with ID ${this.data.personalAccessToken.id} not found.`;
}
